import SearchPageContainer from './SearchPageContainer';

export default SearchPageContainer;
